import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import useOcapiSite from '../../hooks/useOcapiSite'
import {PayPalMessages, usePayPalScriptReducer} from '@paypal/react-paypal-js'

const DEFAULT_STYLE = {
    layout: 'text',
    logo: {
        type: 'primary'
    },
    text: {
        color: 'black',
        size: 14
    }
}

const PaypalPayLater = ({amount, currency, placement}) => {
    const {enablePaypalLater, paypalLaterClientID} = useOcapiSite().customPreferences

    const [{isInitial}, dispatch] = usePayPalScriptReducer()

    // load paypal on mount
    useEffect(() => {
        if (enablePaypalLater && paypalLaterClientID && isInitial) {
            dispatch({
                type: 'setLoadingStatus',
                value: 'pending'
            })
        }
    }, [dispatch, enablePaypalLater, paypalLaterClientID, isInitial])

    if (!enablePaypalLater || !paypalLaterClientID || !(amount > 0) || !currency) {
        return null
    }

    return (
        <PayPalMessages
            amount={amount}
            currency={currency}
            placement={placement}
            style={DEFAULT_STYLE}
            forceReRender={[amount, currency]}
        />
    )
}

PaypalPayLater.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    placement: PropTypes.oneOf(['home', 'category', 'product', 'cart', 'payment'])
}

export default PaypalPayLater
